export default __webpack_public_path__ + "32eff4dbdeadd8f59bdb0c2f211408de.png";